import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import authReducer from './Reducers/AuthReducer';
import userReducer from './Reducers/UserReducer';
import announcementReducer from './Reducers/AnnouncementReducer';
import eventMasterReducer from './Reducers/EventMasterReducer';
import adminInquiryReducer from './Reducers/AdminInquiryReducer';
import getInTouchReducer from './Reducers/GetInTouchReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  announcement: announcementReducer,
  eventMaster: eventMasterReducer,
  adminInquiry: adminInquiryReducer,
  getInTouch: getInTouchReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;

